<template>
  <div>
    <b-modal
      size="lg"
      id="create"
      title="LANÇAR SERVIÇO"
      hide-footer
      no-close-on-backdrop
    >
      <new-service
        :resident="resident"
        :services="services"
        @success="paginate"
      />
    </b-modal>
    <b-modal
      title="DETALHES DO SERVIÇO"
      id="details"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <details-service :service="service" />
    </b-modal>
    <b-modal
      title="GERAR MOVIMENTAÇÃO NA CONTA CORRENTE DO RESIDENTE"
      id="status"
      hide-footer
      no-close-on-backdrop
    >
      <status-service :service="service" @success="paginate" />
    </b-modal>
    <b-modal
      title="EDITAR LANÇAMENTO"
      id="edit"
      hide-footer
      no-close-on-backdrop
    >
      <edit-service :service="service" @success="paginate" />
    </b-modal>
    <b-modal id="filter" no-close-on-backdrop hide-footer title="FILTRAR">
      <div class="row">
        <div class="col-md-12 pt-0 pb-0">
          <label class="m-0">STATUS</label>
          <v-select
            :items="[
              { value: null, text: 'TODOS' },
              { value: 1, text: 'FATURAMENTO PENDENTE' },
              { value: 0, text: 'FATURADO' },
            ]"
            v-model="status"
            dense
            label=""
            outlined
            hide-details
            item-value="value"
            item-text="text"
          />
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <label class="m-0">SERVIÇO</label>
          <v-select
            :items="[{ id: '', description: 'TODOS' }, ...services]"
            v-model="service_id"
            dense
            label=""
            outlined
            hide-details
            item-value="id"
            item-text="description"
          />
        </div>
        <div class="col-md-6">
          <label>DATA INICIAL</label>
          <input type="date" v-model="start" class="form-control" />
        </div>
        <div class="col-md-6">
          <label>DATA FINAL</label>
          <input type="date" v-model="end" class="form-control" />
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn @click="handleFilter" class="btn-filter" type="relief">
            <i class="fas fa-filter mr-2 text-twenty"></i>
            FILTRAR
          </v-btn>
        </div>
      </div>
    </b-modal>
    <div class="row">
      <div class="col-md-12 text-right">
        <v-btn
          @click="$bvModal.show('filter')"
          class="btn-filter mr-2"
          type="relief"
        >
          <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
        </v-btn>
        <v-btn
          v-if="permission('write', 'resident_service')"
          @click="$bvModal.show('create')"
          class="btn-two-add"
        >
          <i class="fas fa-plus mr-2 text-twenty"></i>LANÇAR SERVIÇO
        </v-btn>
      </div>
      <div class="col-md-12">
        <b-overlay :show="loading" opacity="0.99">
          <div v-show="data.length === 0" class="v-clean p-5">
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <v-data-table
            v-show="data.length > 0"
            dense
            :headers="headers"
            :items="data"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            :options.sync="options"
            :server-items-length="total"
          >
            <template v-slot:[`item.status`]="{ item }">
              <div
                v-if="item.status == 0"
                class="d-flex align-items-center justify-content-center"
              >
                <span>FATURADO</span>
                <v-icon class="ml-2" small color="success">
                  mdi-check-circle-outline
                </v-icon>
              </div>
              <div
                v-else
                class="d-flex align-items-center justify-content-center"
              >
                <span>FATURAMENTO PENDENTE</span>
                <v-icon class="ml-2" small color="orange">
                  mdi-information-outline
                </v-icon>
              </div>
            </template>
            <template v-slot:[`item.date`]="{ item }">
              {{ moment(item.date).format("DD/MM/YYYY") }}
            </template>
            <template v-slot:[`item.service`]="{ item }">
              <v-tooltip bottom max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <p class="m-0 limit-text worksansr">
                      {{ item.service_description }}
                    </p>
                  </div>
                </template>
                <span>{{ item.service_description }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.quantity`]="{ item }">
              {{ item.quantity }}
            </template>
            <template v-slot:[`item.total`]="{ item }">
              R$
              {{
                formatPrice(
                  parseInt(item.quantity) * parseFloat(item.value_sale)
                )
              }}
            </template>
            <template v-slot:[`item.details`]="{ item }">
              <v-btn small class="btn-primary m-1" @click="handleDetails(item)">
                <i class="fas fa-eye mr-2"></i>DETALHES
              </v-btn>
              <v-btn
                v-if="
                  item.status == 1 && permission('edit', 'resident_service')
                "
                small
                class="btn-edit m-1"
                @click="handleEdit(item)"
              >
                <i class="fas fa-edit mr-2"></i>EDITAR
              </v-btn>
              <!-- <v-btn
                v-if="
                  item.status == 1 && permission('write', 'resident_service')
                "
                small
                class="btn-i m-1"
                @click="handleStatus(item)"
              >
                <i class="fas fa-check mr-2"></i>MOVIMENTAÇÃO
              </v-btn> -->
              <confirmation-dialog
                v-if="
                  item.status == 1 && permission('remove', 'resident_service')
                "
                small
                message-title="EXCLUIR?"
                message-body="Deseja realmente excluir o lançamento do serviço?"
                open-class="btn-delete m-1"
                open-left-icon="fa-trash"
                open-text="EXCLUIR"
                @yes="deleteService(item.id)"
              />
            </template>
          </v-data-table>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import ConfirmationDialog from "../../../Components/ConfirmationDialog.vue";

import NewService from "./service/new.vue";
import DetailsService from "./service/details.vue";
import StatusService from "./service/status.vue";
import EditService from "./service/edit.vue";

import api from "../../../../services/api";

import routes from "../../../../routes";

import { formatPrice } from "../../../../lib/format";

import moment from "moment";

import permission from "../../../../lib/permission";

export default {
  name: "Service",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    NewService,
    DetailsService,
    StatusService,
    EditService,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      status: null,
      service_id: "",
      resident_id: "",
      start: moment().subtract(30, "days").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),

      total: 0,
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "DATA DO SERVIÇO", value: "date", sortable: false },
        { text: "SERVIÇO", value: "service", sortable: false },
        { text: "QTD.", value: "quantity", sortable: false },
        { text: "TOTAL", value: "total", sortable: false },
        { text: "DETALHES", value: "details", sortable: false },
      ],

      data: [],
      services: [],
      service: {},

      loading: false,

      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    formatPrice,
    permission,

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.getServices();
      this.paginate();
    },

    handleDetails(service) {
      this.service = service;
      this.$bvModal.show("details");
    },

    handleEdit(service) {
      this.service = service;
      this.$bvModal.show("edit");
    },

    handleStatus(service) {
      this.service = service;
      this.$bvModal.show("status");
    },

    handleFilter() {
      this.options.page = 1;
      this.paginate();
    },

    async getServices() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/service/paginate");

        const { error, errors, services } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.services = services;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, service_id, start, end, status } = this;

        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        let params = {
          resident_id,
          service_id,
          start,
          end,
          status,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
        };

        const response = await api.get("/rest-home/family/services", {
          params,
        });

        const { error, errors, data, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
